// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js-new/" + (chunkId === 918 ? "Account" : chunkId) + "-" + {"260":"33d271","918":"7c6b57"}[chunkId] + ".js";
};